import React, { useState, useEffect } from 'react';

import './StatusController.scss'

import Axios from 'axios';

import { connect } from 'react-redux'

import { hostDetect } from '../../../../config/envConfig';

import { Clock, Play, Pause, Square, Trash, X } from "react-feather";

import { setAlert } from '../../../../redux/actions/alertActions';



const StatusController = ({ status, id, updateAdsList, setAlert }) => {
	
	const handleClickStatus = (status) => {
		
		let formData = new FormData();
		formData.append('status', status);

		let apiOptions = {
			withCredentials: true
		}

		Axios.post(`${hostDetect('api')}/push-ad/update-status/?id=${id}`, formData, apiOptions)
			.then(response => {

				const success = response.data.success;

				if(success){
					updateAdsList(id, status)
					setAlert('success', 'Статус обновлен!');
				} else {
					let errMessage = response.data.data.message;
					setAlert('error', errMessage);
				}
			})
			.catch(err => {
				setAlert('error', 'Не получилось отправить запрос!');
			})
	}

	const switchStatus = () => {
		switch (status) {
			case "0":
				// moderated
				return <Clock size={14} />
			case "10":
				// declined
				return <X size={14} />
		  	case "30":
				// active
		    	return <Play size={14}/>
		  	case "50":
				// stopped
		  		return <Square size={14}/>
		  	case "100":
				// archived
		  		return <Trash size={14}/>
		}
	}

	const statusShort = () => {
		switch (status) {
			case "0":
				// moderated
				return 'На модерации'
			case "10":
				// declined
				return 'Отклонено'
			case "30":
				// active
		    	return 'Запущено'
			case "50":
				// stopped
		  		return 'Остановлено'
			case "100":
				// deleted
		  		return 'Удалено'
		}
	}

	return (
		<div className="btn-group dropright status-controller">
            <button className="btn btn-white dropdown-toggle" data-toggle="dropdown" aria-expanded="false" title={statusShort()}>
                {switchStatus()}
            </button>
            <div className="dropdown-menu bg-dark" role="menu" x-placement="right-start">
                <a className={'dropdown-item d-flex align-items-center ' + (status === "0" || status === "10" || status === "30" || status === "100" ? 'disabled' : '')} onClick={()=>handleClickStatus("30")}>
                    <Play size={14}/> Запустить
                </a>
                <a className={'dropdown-item d-flex align-items-center ' + (status === "0" || status === "10" || status === "50" || status === "100" ? 'disabled' : '')} onClick={()=>handleClickStatus("50")}>
                    <Square size={14}/> Остановить
                </a>
                <a className={'dropdown-item d-flex align-items-center ' + (status === "100" ? 'disabled' : '')} onClick={()=>handleClickStatus("100")}>
                    <Trash size={14}/> Удалить
                </a>
                <li className="dropdown-divider"></li>
                <p className="dropdown-item mb-0" style={{fontSize: '12px'}}>
                    {statusShort()}
                </p>
            </div>
  	    </div>
	)
}


const mapDispatchToProps = {
  setAlert
}

export default connect(null, mapDispatchToProps)(StatusController)